export default __webpack_public_path__ + "static/media/desktop_notification.d79efd65.png";